import React from "react";
import { useAuth } from "react-oidc-context";
import {
  Container,
  ContentLayout,
  Header,
  SpaceBetween,
} from "@amzn/awsui-components-react-v3/polaris";
import { PageLayout } from "../components/page-layout";
import { useSetOTPPin } from "../hooks/pin";
import { PinForm } from "../components/pin-form";
import { Alerts } from "../components/alerts";
import { Alerts as AlertsType } from "../lib/types";
import { RegistrationMessages, PagePaths } from "../lib/constants";
import { OTP_PIN_PRESET } from "../lib/pin-presets";
import { Breadcrumbs } from "../components/breadcrumbs";

const breadcrumbItems = [
  { href: "#", text: "Key Management" },
  { href: PagePaths.SET_OTP_PIN, text: "Set OTP PIN" },
];

export const SetOtpPin = () => {
  const auth = useAuth();
  const { setPin, pinError, isPinSuccess, isPinLoading } = useSetOTPPin();

  const alerts: AlertsType = isPinSuccess
    ? {
        successfully_registered_alert: {
          message: RegistrationMessages.OTP_PIN_SET_SUCCESS,
          ariaLabel: "Success",
          type: "success",
        },
      }
    : {};

  return (
    <PageLayout auth={auth}>
      <ContentLayout
        notifications={<Alerts items={alerts} />}
        breadcrumbs={<Breadcrumbs items={breadcrumbItems} />}
        headerVariant="high-contrast"
        header={<Header variant="h1">OTP Pin Registration</Header>}
        defaultPadding
      >
        <SpaceBetween direction="vertical" size="l">
          <Container header={<Header variant="h2">Set your OTP PIN</Header>}>
            <PinForm
              error={pinError}
              onSubmit={setPin}
              isLoading={isPinLoading}
              {...OTP_PIN_PRESET}
            />
          </Container>
        </SpaceBetween>
      </ContentLayout>
    </PageLayout>
  );
};
